import React from 'react'
import './Product.css'
import { useStateValue } from './State'

function Product({title,price,img_url,rating}) {
    const [{cart},dispatch]=useStateValue();
     
    const add=()=>{
         dispatch({
             type:'ADD_TO_CART',
             item:{
                  title:title,
                  price:price,
                  img_url:img_url,
                  rating:rating,
             },
         });

         
    };

    return (
        <div className="pro">
            <div className="desc">
                <p>{title}</p>
                  <p className="price">
                     <small>$</small>
                     <strong>{price}</strong>
                   </p>
            
               <div className="rating">
                   {Array(rating).fill().map((_,i)=>(<p>🌟</p>))}
                  
              </div>
            </div>
            <img src={img_url} alt="" />
            <button onClick={add}>Add to Cart</button>
        </div>
    )
}

export default Product
